// REALTIME_DATA (ID 128) fields actually populated by the firmware's
// SLab_SendMainBoardInfo(). All other RealtimeDataMessage fields are left
// zero and should be hidden from the UI.
export const MultiMotorBoardRealtimeKeys = [
  'batteryVoltage',
  'controllerState',
  'uptimeMs',
  'faultsBitmapLower32',
  'faultsBitmapUpper16'
] as const
